import { baseConfig } from '@adornis/config/baseConfig.js';

const qaWhatsappNumbers = ['+491713608863', '+393342861950'];

const whatsappWhitelistByDeployment: Record<string, string[] | undefined> = {
  production: undefined,
  development: qaWhatsappNumbers,
  staging: ['+491713608863', '+393342861950', '+491603347868', '+4915122819718'],
  qa: qaWhatsappNumbers,
  qa2: qaWhatsappNumbers,
  testing: qaWhatsappNumbers,
};

const deployment = baseConfig.get('DEPLOYMENT');

// Only an own key of `production` is open (`undefined`). A missing or unknown
// deployment must not fall through that same `undefined`, which the client treats
// as "no whitelist".
export const whatsappDeploymentWhitelist: string[] | undefined = Object.hasOwn(
  whatsappWhitelistByDeployment,
  deployment,
)
  ? whatsappWhitelistByDeployment[deployment]
  : [];
